import React, { useCallback, useState } from 'react';
import { PageHeader } from '../components/PageHeader';
import { WorldCard } from '../components/WorldCard';
import { WorldLessonsDialog } from '../components/WorldLessonsDialog';
import { TryFreeLink } from '../components/TryFreeLink';
import { worlds, type World } from '../data/worlds';
import { pricing } from '../lib/pricing';
export function Worlds() {
  const [open, setOpen] = useState(false);
  // Kept after close so the dialog can animate out with its content.
  const [activeWorld, setActiveWorld] = useState<World | null>(null);
  const [trigger, setTrigger] = useState<HTMLButtonElement | null>(null);
  const handleOpen = useCallback((world: World, button: HTMLButtonElement) => {
    setActiveWorld(world);
    setTrigger(button);
    setOpen(true);
  }, []);
  const handleClose = useCallback(() => setOpen(false), []);
  return <>
      <PageHeader title={`${pricing.worldCount} worlds to wander through`} intro={`Ten adventures in every world, ${pricing.lessonCount} in all, with more added over time. A child picks whatever looks interesting. With a subscription, every world is included, and there is no order to follow.`} data-id="element-468" data-mp="32urnl6g72563" />

      <section aria-label="All worlds" className="bg-cream" data-id="element-469" data-mp="9rrzhrijet2u">
        <div className="mx-auto max-w-content px-5 py-16 sm:px-6 md:py-20" data-id="element-470" data-mp="9p5t3v7dujm7">
          <ul className="grid grid-cols-1 gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-471" data-mp="4qkshuo7xxx8">
            {worlds.map(world => <li key={world.slug} data-id="element-472" data-mp="ipkgd03wq8sc">
                <WorldCard world={world} withDescription onOpen={handleOpen} data-id="element-473" data-mp="dtlvvnlp9ax7" />
              </li>)}
          </ul>

          <div className="mt-20 flex flex-col items-start gap-5 rounded-4xl bg-lavender p-8 sm:flex-row sm:items-center sm:justify-between md:p-10" data-id="element-474" data-mp="sh6yzhikra54">
            <p className="max-w-lg font-display text-[24px] leading-snug text-ink" data-id="element-475" data-mp="11i54y5ckprqc">
              All {pricing.lessonCount} adventures are included in the subscription. Want to see one first?
            </p>
            <TryFreeLink data-id="element-476" data-mp="14kjew32oq73h" />
          </div>
        </div>
      </section>

      <WorldLessonsDialog open={open} world={activeWorld} returnFocusTo={trigger} onClose={handleClose} data-id="element-477" data-mp="14i6lmtrh8ab4" />
    </>;
}